import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
// import Dictaphone from "components/Dictaphone";
import GradientTextField from "@/components/GradientTextField";
import React from "react";
var useStyles = makeStyles(function (theme) { return ({
    transparentInput: {
        '& .MuiInputBase-root': {
            backgroundColor: 'transparent',
            color: '#fff',
            border: 'none',
            '&:hover': {
                border: 'none'
            },
        },
        '& .MuiInput-underline:before': {
            borderBottom: 'none'
        },
        '& .MuiInput-underline:after': {
            borderBottom: 'none'
        },
        '& .MuiInputBase-input': {
            backgroundColor: 'transparent',
            '&::placeholder': {
                color: '#000',
                opacity: 0.5,
                fontSize: '1.5rem'
            }
        }
    }
}); });
export default (function (_a) {
    var placeholder = _a.placeholder, onSendMessage = _a.onSendMessage;
    var dictaphoneRef = React.useRef(null);
    var inputRef = React.useRef(null);
    var _b = React.useState(''), input = _b[0], setInput = _b[1];
    var classes = useStyles();
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    var keyPress = function (e) {
        if (e.keyCode === 13 && (e.ctrlKey || e.metaKey)) {
            e.preventDefault();
            setInput(function (prev) { return "".concat(prev, "\n"); });
        }
        else if (e.keyCode === 13) {
            e.preventDefault();
            handleSendMessage();
        }
        else if (e.keyCode === 32) {
            // Prevent space bar from scrolling the page
            e.stopPropagation();
        }
    };
    var stopDictaphone = function () {
        var _a;
        //@ts-ignore
        (_a = dictaphoneRef === null || dictaphoneRef === void 0 ? void 0 : dictaphoneRef.current) === null || _a === void 0 ? void 0 : _a.stop();
    };
    var handleUserInputChange = function (e) {
        var _a;
        setError(null);
        stopDictaphone();
        setInput((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
    };
    var validateTextField = function (input) {
        // Check if the input has at least 10 characters
        if (input.length < 10) {
            return "Please ask a valid question";
        }
        // Check if the input ends with a question mark
        if (!input.endsWith('?')) {
            return "The question must end with a question mark.";
        }
        // Split the input into words
        var words = input.trim().split(/\s+/);
        // Check if the input contains at least 2 words with at least one alphabetic character each
        var validWords = words.filter(function (word) { return /[a-zA-Z]/.test(word); });
        if (validWords.length < 2) {
            return "The question must contain at least 2 valid words.";
        }
        // If all conditions are met, return null indicating no errors
        return null;
    };
    var handleSendMessage = function () {
        var isInvalid = validateTextField(input);
        if (!isInvalid) {
            setError(null);
            stopDictaphone();
            onSendMessage(input.trim());
            setInput('');
        }
        else {
            setError(isInvalid);
        }
    };
    return (_jsxs(Box, { children: [_jsx(GradientTextField, { inputProps: {
                    ref: inputRef,
                }, placeholder: placeholder || "Ask your question here..", multiline: true, fullWidth: true, error: Boolean(error), helperText: error, onKeyDown: keyPress, value: input, onChange: handleUserInputChange, maxRows: 8, InputProps: {
                    endAdornment: (_jsx(Box, { display: "flex", flexDirection: "row", alignItems: "center" }))
                } }), _jsx(Box, { sx: { display: 'flex', flexDirection: 'row', justifyContent: 'flex-end' }, children: _jsx(Button, { onClick: handleSendMessage, sx: { my: 1 }, variant: "contained", children: "Submit" }) })] }));
});
